import {colorNames, useNamedColor} from '@github-ui/use-named-color'

import styles from './IssueTypePickerItemLeadingVisual.module.css'

export function NoTypeIndicator() {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <rect width="12" height="12" rx="6" fill="var(--bgColor-muted)" />
      <rect
        x="1"
        y="1"
        width="10"
        height="10"
        rx="5"
        stroke="var(--borderColor-muted)"
        strokeWidth="2"
        strokeDasharray="2.5 1.4"
        strokeDashoffset="1.25"
      />
    </svg>
  )
}

export type IssueTypeColor =
  | 'BLUE'
  | 'GRAY'
  | 'GREEN'
  | 'ORANGE'
  | 'PINK'
  | 'PURPLE'
  | 'RED'
  | 'YELLOW'
  // eslint-disable-next-line relay/no-future-added-value
  | '%future added value'

export const createIssueTypePickerItemLeadingVisual = (color: IssueTypeColor) =>
  function IssueTypePickerItemLeadingVisual() {
    const effectiveColor = colorNames.find(c => c === color)
    const {bg, accent} = useNamedColor(effectiveColor)
    return <div style={{'--bg': `${bg}`, '--accent': `${accent}`}} className={styles.issueTypeColorIndicator} />
  }

export function IssueTypeColorIndicator({color}: {color: IssueTypeColor}) {
  const effectiveColor = colorNames.find(c => c === color)
  const {bg, accent} = useNamedColor(effectiveColor)
  return <div style={{'--bg': `${bg}`, '--accent': `${accent}`}} className={styles.issueTypeColorIndicator} />
}
